// Search here. https://remixicon.com/

export const icons = {
  "ec-approvals": "ri-stamp-line",
  "ec-payslips": "ri-file-list-3-line",
  "ec-leave-requests": "ri-calendar-check-line",
  "ec-proof-of-employment": "ri-file-paper-2-line",
};
